import { apiClient } from "@/lib/apiClient";

/**
 * Wallet Service - Following established patterns
 * Uses apiClient for all API calls with proper URL patterns
 */

export interface WalletBalance {
  balance: number;
  pendingBalance: number;
}

export interface WalletTransaction {
  id: string;
  type: "credit" | "debit";
  amount: number;
  description: string;
  status: "completed" | "pending" | "failed";
  createdAt: string;
  reference?: string;
}

export interface AddFundsRequest {
  amount: number;
}

export interface WithdrawFundsRequest {
  amount: number;
}

export interface Transaction {
  amount: number;
  notes?: any;
  order_id: string;
  payment_id: string;
  processed_at?: string;
  status: string;
  timeline?: Array<{
    status: string;
    updated_at: number;
  }>;
}

export interface CreateOrderResponse {
  orderId: string;
  status: string;
  transaction: {
    amount: number;
    balance: number;
    store_id: string;
    transaction: Transaction;
    transaction_id: string;
    type: "add" | "withdraw" | "refund" | "charge";
    user_id: string;
  };
}

export interface WalletTransactionResponse {
  id: string;
  amount: number;
  status: string;
  paymentId: string;
  userId: string;
}

// GET /api/v1/admin/{storeId}/wallet/balance
export const getBalance = async () => {
  return await apiClient.get("/api/v1/admin/:storeId/wallet/balance");
};

// GET /api/v1/admin/{storeId}/wallet/transactions
export const getTransactions = async (page: number = 1, limit: number = 10) => {
  const params = {
    page: page.toString(),
    limit: limit.toString(),
  };

  return await apiClient.get("/api/v1/admin/:storeId/wallet/transactions", {
    params,
  });
};

// POST /api/v1/admin/{storeId}/wallet/add
export const addFunds = async (amount: number) => {
  return await apiClient.post("/api/v1/admin/:storeId/wallet/add", { amount });
};

// POST /api/v1/admin/{storeId}/wallet/withdraw
export const withdrawFunds = async (amount: number) => {
  return await apiClient.post("/api/v1/admin/:storeId/wallet/withdraw", {
    amount,
  });
};

// POST /api/v1/admin/{storeId}/wallet/add/{paymentId}/cancel
export const cancelPayment = async (paymentId: string) => {
  return await apiClient.post(
    `/api/v1/admin/:storeId/wallet/add/${paymentId}/cancel`,
  );
};

// POST /api/v1/admin/{storeId}/wallet/withdraw/{paymentId}/request-update
export const requestWithdrawalUpdate = async (paymentId: string) => {
  return await apiClient.post(
    `/api/v1/admin/:storeId/wallet/withdraw/${paymentId}/request-update`,
  );
};
